module.exports = __webpack_public_path__ + "img/videoPoster5.d2f3b2d6.jpg";